import { render, staticRenderFns } from "./income_shalt.vue?vue&type=template&id=4705ff2c&"
import script from "./income_shalt.vue?vue&type=script&lang=js&"
export * from "./income_shalt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports